import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentPreview = ({ file }) => {
  const getDocumentIcon = () => {
    if (file?.type?.includes('pdf')) return 'FileText';
    if (file?.type?.includes('word') || file?.type?.includes('document')) return 'FileText';
    if (file?.type?.includes('sheet') || file?.type?.includes('excel')) return 'FileSpreadsheet';
    if (file?.type?.includes('presentation') || file?.type?.includes('powerpoint')) return 'Presentation';
    return 'File';
  };

  const getDocumentTypeName = () => {
    if (file?.type?.includes('pdf')) return 'PDF Document';
    if (file?.type?.includes('word') || file?.type?.includes('document')) return 'Word Document';
    if (file?.type?.includes('sheet') || file?.type?.includes('excel')) return 'Excel Spreadsheet';
    if (file?.type?.includes('presentation') || file?.type?.includes('powerpoint')) return 'PowerPoint Presentation';
    return 'Document';
  };

  return (
    <div className="w-full h-full bg-muted rounded-lg flex flex-col items-center justify-center p-8">
      <div className="bg-card rounded-full p-6 mb-6 shadow-md">
        <Icon name={getDocumentIcon()} size={64} className="text-primary" />
      </div>
      <h3 className="text-lg font-semibold text-foreground mb-2">
        {getDocumentTypeName()}
      </h3>
      <p className="text-sm text-muted-foreground text-center max-w-md mb-6">
        Preview is not available for this file type. Download the file to view its contents.
      </p>
      <div className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
        <div className="flex-1 bg-card border border-border rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="FileText" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">File Name</span>
          </div>
          <p className="text-sm font-medium text-foreground truncate">{file?.name}</p>
        </div>
        
        <div className="flex-1 bg-card border border-border rounded-lg p-4">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="HardDrive" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">File Size</span>
          </div>
          <p className="text-sm font-medium text-foreground font-mono">
            {(file?.size / 1024 / 1024)?.toFixed(2)} MB
          </p>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreview;